export default (params) => ({
  trigger: {
    name: 'product_plus.cancel_product_plus_consent',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
          'free_drying',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'cancel',
      },
    },
    nonInt: true,
  },
});
